import { render } from "./AppCopyRights.vue?vue&type=template&id=74c4b1fb"
import script from "./AppCopyRights.vue?vue&type=script&lang=js"
export * from "./AppCopyRights.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__